import { z } from 'zod';
// TODO: someday it'd be nice to use the DB exported enum for this!
const claimSource = {
    Customer_App: 'Customer_App',
    Merchant_App: 'Merchant_App',
    Retool: 'Retool',
    Gorgias_Ticket_Widget: 'Gorgias_Ticket_Widget',
    Zowie_Inbox_Integration: 'Zowie_Inbox_Integration',
    Gladly_Hero_Integration: 'Gladly_Hero_Integration',
    Kustomer_App_Integration: 'Kustomer_App_Integration',
    Zendesk_App_Integration: 'Zendesk_App_Integration',
    Public_API: 'Public_API',
};
export const sharedClaimSourceUnion = z.enum(claimSource);
/** Merchant-facing names for where a claim came from. */
export const claimSourceName = {
    Customer_App: 'Customer Portal',
    Gladly_Hero_Integration: 'Gladly Hero Integration',
    Merchant_App: 'Merchant Admin App',
    Gorgias_Ticket_Widget: 'Gorgias Ticket Widget',
    Retool: 'Corso Concierge Team',
    Zowie_Inbox_Integration: 'Zowie Inbox Integration',
    Kustomer_App_Integration: 'Kustomer App Integration',
    Zendesk_App_Integration: 'Zendesk App Integration',
    Public_API: 'Corso Commerce API',
};
export const shippingClaimSourceMerchantApp = sharedClaimSourceUnion.extract([
    'Merchant_App',
    'Kustomer_App_Integration',
    'Zendesk_App_Integration',
]);
//# sourceMappingURL=claimSource.js.map